module.exports = __webpack_public_path__ + "img/gongshui5.206c9132.png";